module.exports = __webpack_public_path__ + "media/images/pic/gallery/2018/szkola-letnia-588a41b397bbbebac2d1e0b69e601bc9.jpg";